import { render, staticRenderFns } from "./FBushing.vue?vue&type=template&id=4fa64dd4&scoped=true"
import script from "./FBushing.vue?vue&type=script&lang=ts"
export * from "./FBushing.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa64dd4",
  null
  
)

export default component.exports